import { makeStyles } from '@material-ui/core/styles';
import typography from '@/theme/typography';
import { colorMap, ColorNames, SecondaryColors } from '@/utils/constants';

const useStyles = makeStyles(
  ({ spacing, breakpoints }) => ({
    root: {
      '&.aos-true .react-reveal': {
        animationDuration: '0.01ms !important',
        animationIterationCount: '1 !important',
        transitionDuration: '0.01ms !important',
        scrollBehavior: 'auto !important',
      },
      '& [class*="GenDetailContent-root"] > .capture-clicks': {
        width: '100%',
        flex: 1,
      },
    },
    detailContent: {
      height: '100%',
    },
    columnContent: {
      '& .columns': {
        margin: spacing(0, -2),

        '& .column': {
          padding: spacing(0, 2),

          '&.right-column $card': {
            [breakpoints.down('sm')]: {
              backgroundColor: colorMap[ColorNames.mediumGray],
            },
          },

          '&.left-column:not(:last-child)': {
            [breakpoints.down('sm')]: {
              marginBottom: spacing(0),
            },
          },

          '& .detail-content': {
            flex: 1,
          },
        },
      },
    },
    columnVerticalAlignmentTop: {
      '& $card': {
        alignItems: 'flex-start',
      },
    },
    columnVerticalAlignmentCenter: {
      '& $card': {
        alignItems: 'center',
      },
    },
    columnVerticalAlignmentBottom: {
      '& $card': {
        alignItems: 'flex-end',
      },
    },
    content: {
      '& [data-datalayer-position]': { height: '100%' },
      '& > * > * + *': {
        [breakpoints.up('md')]: {
          marginTop: spacing(4),
        },
      },
    },
    myBusiness: {},
    form: {
      '& form': {
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
      },
    },
    noCard: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',

      [breakpoints.up('md')]: {
        borderRadius: '4px',
        overflow: 'hidden',
      },
    },
    card: {
      padding: spacing(6, 4, 6),
      display: 'flex',
      height: '100%',

      [breakpoints.up('md')]: {
        backgroundColor: colorMap[ColorNames.mediumGray],
        borderRadius: '4px',
        padding: spacing(7, 5, 9),
        width: '100%',
      },

      [breakpoints.down('sm')]: {
        marginLeft: spacing(-4),
        marginRight: spacing(-4),
        width: `calc(100% + ${spacing(8)}px) !important`,
      },
    },
    rtc: {
      '& h5': {
        color: SecondaryColors.main,
      },
    },
    esTabbedListContent: {
      '& .portal-carousel': {
        '& .portal-carousel-card-content': {
          background: colorMap[ColorNames.mediumGray],

          [breakpoints.up('md')]: {
            background: colorMap[ColorNames.charcoal],
          },
        },
      },
    },
    tabbedListContent: {
      '& .portal-carousel': {
        width: '100vw !important',
        marginLeft: '-40px',
        marginRight: '-40px',
        [breakpoints.up('md')]: {
          '& .swiper-dot-navigation': {
            paddingRight: '40px',
          },
          width: 'calc(100% + 80px)!important',
        },
        '& .swiper-slide:first-child ': {
          marginLeft: '40px',
        },
        '& .swiper-slide:last-child ': {
          marginRight: '40px',
        },
        '& .portal-carousel-card-content': {
          background: colorMap[ColorNames.mediumGray],

          [breakpoints.up('md')]: {
            background: colorMap[ColorNames.charcoal],
          },
        },
      },
    },
    horizontalButtonSet: {},
    iconTextGrid: {
      '& .left-group-description--custom': {
        '& h1, h2, h3, h4, h5, h6': {
          ...typography.h4,
        },
      },
    },
  }),
  { name: 'GenDashboard' },
);

export default useStyles;
